import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=08087644&scoped=true&"
import script from "./expert.vue?vue&type=script&lang=ts&"
export * from "./expert.vue?vue&type=script&lang=ts&"
import style0 from "./expert.vue?vue&type=style&index=0&id=08087644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08087644",
  null
  
)

export default component.exports